/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import Immutable from "immutable";

import reducers from "../reducers";

function reduxStore(initialState = Immutable.Map()) {
  let middlewares = applyMiddleware(thunk);
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    middlewares = compose(
      middlewares,
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__()
    );
  }

  const store = createStore(reducers, initialState, middlewares);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", () => {
      // We need to require for hot reloadign to work properly.
      const nextReducer = require("../reducers"); // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

export default reduxStore;
